<template>
  <select-input
    id="forum-sort-select"
    :options="optionsWithSelection"
    @change="(value) => $emit('change', value)"
  ><span class="visually-hidden">Select a forum sorting option</span>
  </select-input>
</template>

<script>
import SelectInput from '@/components/Inputs/SelectInput.vue';

export default {
  name: 'ForumSort',
  components: {
    SelectInput,
  },
  props: {
    selected: {
      type: String,
      default: 'RECENT',
    },
  },
  data() {
    return {
      sortOptions: [
        { value: 'RECENT', name: 'Recent', selected: true },
        { value: 'POPULAR', name: 'Popular', selected: false },
        { value: 'UNANSWERED', name: 'Unanswered', selected: false },
      ],
    };
  },
  computed: {
    optionsWithSelection() {
      return this.sortOptions.map((option) => {
        if (option.value === this.selected) {
          // eslint-disable-next-line no-param-reassign
          option.selected = true;
        } else {
          // eslint-disable-next-line no-param-reassign
          option.selected = false;
        }
        return option;
      });
    },
  },
};
</script>

<docs>

A select menu to provide sort options for the forums

</docs>
